module.exports = {
    responseActionConstants: {
        bookingFlowResponseActionName: "BookTicketsCheck",
        entryIdResponseActionName: "EntryId",
        formInteractionResponseActionName: "FormInteraction",
    },
};


// WEBPACK FOOTER //
// ./settings/response-action-constants.js